/**
 * The email-service load-reply chain (nylas-emails-pub-sub) signals a broker reply by pushing a
 * plain `NotificationMessage` with this exact copy and no thread/load id. Both consumers — the live
 * chat refetch (`useEmailChat`) and the unread-badge re-sync (`useBrokerReplyNotification`) — match
 * against this single source of truth instead of duplicating the string.
 *
 * Exact (trim + lowercase) equality, not a substring test: the producer emits precisely this text, so
 * exact match still catches every real signal while ignoring unrelated notifications that merely
 * contain the phrase.
 *
 * TODO: replace the copy match with a typed notification `kind` emitted by the producer so the signal
 * isn't coupled to user-facing text (an i18n/copy edit would otherwise silently disable it). Kept as a
 * string match here to avoid a cross-service (@numeo/types + email-service) change in this PR.
 */
const BROKER_REPLY_NOTIFICATION_TEXT = 'new email received'

export const isBrokerReplyNotification = (message: unknown): boolean =>
    typeof message === 'string' && message.trim().toLowerCase() === BROKER_REPLY_NOTIFICATION_TEXT
